/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 13:22:02
 * @LastEditTime: 2021-11-08 16:59:35
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/OrderDetail/TermsAndConditionConsent/index.tsx
 */
import Link from '@/src/components/Link/Link';
import React from 'react';
import { SizeFittingTable } from 'src/components/Antd';
import { SectionWrapper } from 'src/components/Layouts';

import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from '@/src/tools/tools';
import css from './css.module.less';
import { handleOnGetStoreTimezoneUTC } from '@/src/tools/tools';

const tableName = 'TermsAndConditionConsent';
const TermsAndConditionConsent = (props) => {
  const timezoneUTC = handleOnGetStoreTimezoneUTC();
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { tacs = [] } = props;

  const columns = [
    {
      title: replaceI18nVariables(
        getI18n(
          'allOrders.orderDetail.termsAndConditionConsent_columns_time_title',
        ),
        timezoneUTC,
      ),
      key: 'createdDate',
      dataIndex: 'createdDate',
      sorter: (a, b) => {
        const aTime = new Date(a.createdDate).getTime();
        const bTime = new Date(b.createdDate).getTime();
        return aTime - bTime;
      },
      default: true,
      minWidth: 240,
      render: (text) => text,
    },
    {
      title: getI18n(
        'allOrders.orderDetail.termsAndConditionConsent_columns_consent_title',
      ),
      key: 'name',
      dataIndex: 'name',
      default: true,
      minWidth: 400,
    },
    {
      title: getI18n(
        'allOrders.orderDetail.termsAndConditionConsent_columns_action_title',
      ),
      key: 'action',
      default: true,
      align: 'center',
      minWidth: 90,
      childGenerate: (text, record) => {
        const { salesChannelUuid = '', uuid = '' } = record;
        return (
          <Link
            to={`/salesChannel/termsAndCondition/editor/${salesChannelUuid}/${uuid}`}
            className={css.view}>
            {getI18n(
              'allOrders.orderDetail.termsAndConditionConsent_columns_action_childgenerate',
            )}
          </Link>
        );
      },
    },
  ];
  return (
    <SectionWrapper
      title={getI18n(
        'allOrders.orderDetail.termsAndConditionConsent_return_title',
      )}
      containerClassName={css.containerClassName}>
      <SizeFittingTable
        rowKey='uuid'
        pagination={false}
        dataSource={tacs}
        className={css.readyToPickTable}
        id={tableName}
        columns={columns}
      />
    </SectionWrapper>
  );
};
export default TermsAndConditionConsent;
